import React from "react";
import CustomCheckbox from "./CustomCheckbox";
import { SET_ORDER_FILLED_PHONE, SET_ORDER_FILLED_PHONE_RENT } from "../../../../actions/create-bot-type";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import LeftRightForm from "./LeftRightForm";

const SendOrderFilledPhone = (props) => {
  const { rent } = props;
  const newBot = useSelector((state) => state.createBot.newBot);
  const rentBot = useSelector((state) => state.createBot.rentBot);
  const { t } = useTranslation();
  const sendOrderFilledPhone = parseInt(rent ? rentBot.sendOrderFilledPhone : newBot.sendOrderFilledPhone) ? 1 : 0;
  const dispatch = useDispatch();
  const setOrderFilledPhone = (val) => {
    dispatch({
      type: rent ? SET_ORDER_FILLED_PHONE_RENT : SET_ORDER_FILLED_PHONE,
      payload: val ? 1 : 0,
    });
  };

  return (
    <LeftRightForm
      left={<></>}
      right={
        <CustomCheckbox
          val={sendOrderFilledPhone}
          checked={sendOrderFilledPhone}
          callback={setOrderFilledPhone}
          label={t("send-orderfilled-phone")}
          id={"send-orderfilled-phone"}
        />
      }
    />
  );
};

export default SendOrderFilledPhone;
